import { ApolloClient, ApolloProvider, InMemoryCache } from "@apollo/client"
import DealerAppContextsProvider from "DealerApp/contexts/DealerAppContextsProvider"
import Header, { type HeaderProps } from "DealerApp/Layout/Header"
import { apolloLinks } from "lib/ApolloLinks"
import type Texts from "DealerApp/types/texts"
import React, { useEffect } from "react"
import { CountryCode, EntityType } from "DealerApp/lib/scalars"

const client = new ApolloClient({
  link: apolloLinks,
  cache: new InMemoryCache({
    addTypename: true,
  }),
})

type LegacyHeaderProps = HeaderProps & {
  country: CountryCode
  entityId: string
  entityType: EntityType
  texts: Texts
}

const LegacyHeader = (props: LegacyHeaderProps) => {
  useEffect(() => {
    /** Track the user in hubspot */
    window._hsq?.push(["identify", { email: props.user.email }])
  }, [])

  return (
    <DealerAppContextsProvider
      country={props.country}
      entityId={props.entityId}
      entityType={props.entityType}
      user={props.user}
    >
      <ApolloProvider client={client}>
        <Header {...props} />
      </ApolloProvider>
    </DealerAppContextsProvider>
  )
}

export default LegacyHeader
